import { Sparkles } from 'lucide-react';
import { Button } from '@dashai/components/ui/button';
import { cn } from '@dashai/lib/utils';

interface SuggestionPromptsProps {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
  disabled?: boolean;
}

export function SuggestionPrompts({ suggestions, onSelect, disabled }: SuggestionPromptsProps) {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 animate-in fade-in slide-in-from-bottom-2 duration-300">
      {suggestions.map((suggestion, index) => (
        <Button
          key={index}
          variant="outline"
          size="sm"
          onClick={() => onSelect(suggestion)}
          disabled={disabled}
          className={cn(
            "text-xs h-8 px-3 rounded-full",
            "border-muted-foreground/20 bg-background/50",
            "hover:bg-primary/10 hover:border-primary/30",
            "transition-all duration-200",
            "animate-in fade-in slide-in-from-bottom-1",
          )}
          style={{ animationDelay: `${index * 75}ms` }}
        >
          <Sparkles className="h-3 w-3 mr-1.5 text-primary" />
          {suggestion}
        </Button>
      ))}
    </div>
  );
}
